import { z } from 'zod';
import { coveragePlatformServiceConfigSchema } from '../configurations/CoveragePlatformServiceConfig.js';
import { servicesProviderGenericDataSchema } from '../ServicesProviderData.js';
import { Services } from './Services.js';

const servicesProviderCoveragePlatformDataSchema = servicesProviderGenericDataSchema.extend({
    config: z.object({
        [Services.COVERAGE_PLATFORM]: coveragePlatformServiceConfigSchema,
    }),
});

export { servicesProviderCoveragePlatformDataSchema };
//# sourceMappingURL=ServicesProviderCoveragePlatformData.js.map
